const defaultState = {
  customer: {},
  error: null,
  saving: false,
  saved: false
};

const managePortfoliosReducer = (state = defaultState, action) => {
  switch (action.type) {
    case 'ADD_EDIT_PORTFOLIOS_SAVE_PENDING': {
      return {
        ...state, saving: true, error: null
      };
    }
    case 'ADD_EDIT_PORTFOLIOS_SAVE_FULFILLED': {
      return {
        ...state, saving: false, error: null, saved: true, portfolioData: action.payload
      };
    }
    case 'ADD_EDIT_PORTFOLIOS_SAVE_REJECTED': {
      return {
        ...state,
        saving: false,
        saved: false,
        error: action.payload
      };
    }
    default: {
      break;
    }
  }

  return state;
};

export default managePortfoliosReducer;


// WEBPACK FOOTER //
// ./src/reducers/VXC/managePortfolios.js